import React from 'react';

export function TaskWatch() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M8.00009 10.4645C9.3605 10.4645 10.4633 9.36172 10.4633 8.00132C10.4633 6.64091 9.3605 5.53809 8.00009 5.53809C6.63969 5.53809 5.53687 6.64091 5.53687 8.00132C5.53687 9.36172 6.63969 10.4645 8.00009 10.4645Z"
                fill="#ADB0B5"
            />
            <path
                d="M15.7546 7.31859C13.8612 5.03056 10.995 2.82812 8.00003 2.82812C5.00444 2.82812 2.13764 5.0321 0.245476 7.31859C-0.0818254 7.71394 -0.0818254 8.28787 0.245476 8.68322C0.721187 9.25808 1.71849 10.3678 3.05048 11.3374C6.40506 13.7794 9.58761 13.7848 12.9496 11.3374C14.2816 10.3678 15.2789 9.25808 15.7546 8.68322C16.0809 8.28864 16.0826 7.71523 15.7546 7.31859ZM8.00003 4.55239C9.90164 4.55239 11.4486 6.09929 11.4486 8.00091C11.4486 9.90252 9.90164 11.4494 8.00003 11.4494C6.09842 11.4494 4.55151 9.90252 4.55151 8.00091C4.55151 6.09929 6.09842 4.55239 8.00003 4.55239Z"
                fill="#ADB0B5"
            />
        </svg>
    );
}
